module.exports = __webpack_public_path__ + "static/media/customer_icon.b5b20571.svg";